export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2a3.5 3.5 0 013.5 3.5v.586L18.586 3 20 4.414l-4.5 4.5V11.5a3.5 3.5 0 01-5.476 2.889l-1.428 1.428A5.5 5.5 0 0017.5 11.5V11h2v.5a7.5 7.5 0 01-6.5 7.432V22h-2v-3.068a7.47 7.47 0 01-3.825-1.694l-2.468 2.469-1.414-1.414 2.534-2.535A7.46 7.46 0 014.5 11.5V11h2v.5c0 1.028.283 1.989.773 2.812l1.487-1.487a3.484 3.484 0 01-.255-1.145L8.5 11.5v-6A3.5 3.5 0 0112 2zm-.499 10.912A1.492 1.492 0 0013.5 11.5v-.586l-1.999 1.998zM12 4a1.5 1.5 0 00-1.5 1.5v5.586l3-3V5.5A1.5 1.5 0 0012 4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};